import { contramap, getSemigroup, reverse } from 'fp-ts/Ord';

import { Ord as OrdNumber } from 'fp-ts/number';
import { pipe } from 'fp-ts/lib/function';
import { AvailabilityStatus } from '../generated/graphql';
import { byName } from './sorting';
import { PlayerWithAvailability } from './makeAvailabilityMap';

const availabilitySortHierarchy: Record<AvailabilityStatus, number> = {
  AVAILABLE: 10,
  MAYBE: 5,
  UNAVAILABLE: 3,
  UNDECLARED: 0,
};

const byAvailabilityOnly = pipe(
  reverse(OrdNumber),
  contramap(
    (p: PlayerWithAvailability) =>
      availabilitySortHierarchy[p.availability] || 0,
  ),
);

export const byPlayerName = contramap((p: PlayerWithAvailability) => p.player)(
  byName,
);

export const byAvailability = getSemigroup<PlayerWithAvailability>().concat(
  byAvailabilityOnly,
  byPlayerName,
);
